import styled from "styled-components"

export const Content = styled.div`
    margin: 5vh 20vw; 
    text-align: left;
    height: 80vh;
`